import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';

const MobileBottomBar = () => {
  const whatsappMessage = encodeURIComponent(
    `Hello Centurio Prime Team,\n\nI would like to reserve a snooker table.\n\nPreferred Date: [Please Enter Date]\nPreferred Time: [Please Enter Time]\nNumber of Players: [Enter Number]\n\nKindly confirm availability.\n\nThank you.`
  );

  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-black border-t border-gold/30 shadow-lg"
      data-testid="mobile-bottom-bar"
    >
      <div className="grid grid-cols-2">
        {/* Call Button */}
        <a
          href="tel:+923016697234"
          className="flex items-center justify-center gap-2 py-4 text-gold hover:bg-gold/10 transition-colors border-r border-gold/30"
          data-testid="mobile-bar-call-button"
        >
          <Phone className="w-5 h-5" />
          <span className="font-montserrat text-sm uppercase tracking-wider">Call Now</span>
        </a>

        {/* WhatsApp Button */}
        <a
          href={`https://wa.me/923016697234?text=${whatsappMessage}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 py-4 text-gold hover:bg-gold/10 transition-colors"
          data-testid="mobile-bar-whatsapp-button"
        >
          <MessageCircle className="w-5 h-5" />
          <span className="font-montserrat text-sm uppercase tracking-wider">WhatsApp</span>
        </a>
      </div>
    </div>
  );
};

export default MobileBottomBar;
